import { render, staticRenderFns } from "./Paciente.vue?vue&type=template&id=d956bb86&scoped=true"
import script from "./Paciente.vue?vue&type=script&lang=js"
export * from "./Paciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d956bb86",
  null
  
)

export default component.exports